import React from 'react';
import FlowList from './FlowList';

export default function FlowColumn({ visible, flow, selectedId, onSelect, onRemove, onReorder }) {
  return (
    <div
      className={`${visible ? 'flex' : 'hidden'} lg:flex flex-col border-r border-[#EEE9FB] p-4 md:p-5 overflow-y-auto zara-scroll`}
    >
      <FlowList
        flow={flow}
        selectedId={selectedId}
        onSelect={onSelect}
        onRemove={onRemove}
        onReorder={onReorder}
      />
    </div>
  );
}
